import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  onClick?: () => void; 
};

const CancelButton: React.FC<Props> = ({ onClick }) => {
  const {t} = useTranslation();
  return (
    <button
      className="w-[132px] h-[40px] bg-white rounded-lg text-sm border"
      onClick={onClick} 
    >
      {t("cancelbutton.cancel")}
    </button>
  );
};

export default CancelButton;
